import { ElementRef, NgZone, Renderer2, RendererFactory2, } from '@angular/core';
import * as i0 from "@angular/core";
export class AutoDropDirectionDirective {
    constructor(el, ngZone, rendererFactory) {
        this.el = el;
        this.ngZone = ngZone;
        this.rendererFactory = rendererFactory;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    ngAfterViewInit() {
        if (!this.ycnAutoDropDirection)
            return;
        this.ngZone.runOutsideAngular(() => {
            const element = this.el.nativeElement;
            this.observer = new MutationObserver((mutations) => {
                // Only react to class changes on descendant elements (e.g. the menu getting .show).
                // Ignore mutations on the host element itself to avoid an infinite loop
                // since updateDropDirection adds/removes 'dropup' on the host.
                if (mutations.some((m) => m.target !== element)) {
                    this.updateDropDirection(element);
                }
            });
            this.observer.observe(element, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true,
            });
        });
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    updateDropDirection(element) {
        const menu = element.querySelector('.dropdown-menu.show');
        if (!menu) {
            this.renderer.removeClass(element, 'dropup');
            return;
        }
        const parentRect = element.getBoundingClientRect();
        const menuHeight = menu.offsetHeight;
        const spaceBelow = window.innerHeight - parentRect.bottom - 50;
        const spaceAbove = parentRect.top;
        if (menuHeight > spaceBelow && spaceAbove > spaceBelow) {
            this.renderer.addClass(element, 'dropup');
        }
        else {
            this.renderer.removeClass(element, 'dropup');
        }
    }
}
AutoDropDirectionDirective.ɵfac = function AutoDropDirectionDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutoDropDirectionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.RendererFactory2)); };
AutoDropDirectionDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AutoDropDirectionDirective, selectors: [["", "ycnAutoDropDirection", ""]], inputs: { ycnAutoDropDirection: "ycnAutoDropDirection" }, standalone: false });
